import { useContext } from "react";

import { FiltersV2RegistryContext } from "./FiltersV2Context";

const useFiltersV2Registry = () => useContext(FiltersV2RegistryContext);

export default useFiltersV2Registry;
